<template>
  <div class="w-full md:w-1/2 relative">
    <div class="w-[80%] m-auto h-[15vh] flex flex-col justify-end md:h-[25vh]">
      <div class="m-auto flex justify-center md:h-[25vh] mt-16">
        <img
          src="../assets/AccessLogo.png"
          alt=""
          class="w-30 h-14 p-[1px] rounded object-fill"
        />
      </div>
      <h4 class="text-lg font-bold text-[#09518C]">Sign In</h4>
    </div>
    <div class="w-[80%] h-[70vh] m-auto">
      <div class="pt-[16px]">
        <div
          v-if="showErrorMsg"
          class="bg-red-600 text-white text-center mb-3 rounded-md py-4"
        >
          <font-awesome-icon class="mr-2" icon="fa-exclamation-triangle" />
          {{ showErrorMsg }}
        </div>
        <form
          @submit.prevent="onSubmit"
          :class="{ valid: !v$.$error && v$.$dirty, error: v$.$error }"
        >
          <div class="mt-4 mb-4">
            <p class="block text-[#09518C] text-sm font-bold mb-2">
              Employer Code
            </p>
            <div class="flex">
              <input
                class="shadow appearance-none w-full border bg-gray-50 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                v-model="state.code"
                placeholder="Enter employer code"
              />
            </div>
            <div
              class="input-errors text-sm text-red-500 mt-1"
              v-for="error of v$.code?.$errors"
              :key="error.$uid"
            >
              <div class="error-msg">Employer code is required</div>
            </div>
          </div>
          <div class="my-4">
            <p class="block text-[#09518C] text-sm font-bold mb-2">
              Email/Phone Number
            </p>
            <div class="flex">
              <input
                class="shadow appearance-none w-full border bg-gray-50 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                v-model="state.identifier"
                placeholder="Enter email or phone number"
              />
            </div>
            <div
              class="input-errors text-sm text-red-500 mt-1"
              v-for="error of v$.identifier?.$errors"
              :key="error.$uid"
            >
              <div class="error-msg">Email/Phone number is required</div>
            </div>
          </div>
          <div class="my-4">
            <p class="block text-[#09518C] text-sm font-bold mb-2">Password</p>
            <div v-if="showPassword">
              <input
                class="w-full shadow appearance-none border bg-gray-50 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                id="password"
                type="password"
                placeholder="********"
                v-model="state.password"
              />
              <!-- <img :src="lockSolid" class="h-10 w-20 field-icon"  class="" /> -->

              <font-awesome-icon
                style="cursor: pointer"
                @click="toggleShowHide"
                v-if="showPassword"
                class="field-icon text-gray-500"
                icon="eye-slash"
              />
            </div>

            <div v-else>
              <input
                class="w-full shadow appearance-none border bg-gray-50 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                id="password"
                type="text"
                placeholder="********"
                v-model="state.password"
              />
              <font-awesome-icon
                style="cursor: pointer"
                @click="toggleShowHide"
                v-if="!showPassword"
                class="field-icon"
                icon="eye"
              />
            </div>
            <div
              class="input-errors text-sm text-red-500 mt-1"
              v-for="error of v$.password?.$errors"
              :key="error.$uid"
            >
              <div class="error-msg">Password is required</div>
            </div>
          </div>

          <div class="mt-4 flex">
            <input
              v-model="state.check"
              class="float-right"
              formControlName="status"
              type="checkbox"
            />
            <div
              class="text-[#09518C] text-sm font-bold mb-2 cursor-pointer mt-2 ml-3"
            >
              I agree to the terms of the
              <span
                @click="onIndemintyModalOpen"
                class="text-[#8DC63F] hover:text-[#F58220] cursor-pointer"
              >
                Indemnity Clause
              </span>
            </div>
          </div>

          <div
            class="input-errors text-sm text-red-500"
            v-for="error of v$.check?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Please tick this box to agree</div>
          </div>

          <div class="flex">
            <label class="flex items-center">
              <input
                v-model="state.privacyPolicy"
                class="float-right -mt-5"
                formControlName="status"
                type="checkbox"
              />
              <div class="flex">
                <div
                  class="text-gray-700 text-sm font-bold mb-2 cursor-pointer mt-2 ml-3"
                >
                  By ticking this box, I agree to the collection and processing
                  of my personal data in line with the NDPA and Access
                  Pensions’
                  <span
                    class="text-[#8DC63F] hover:text-[#F58220] cursor-pointer"
                  >
                    <a
                      href="hhttps://accesspensions.ng/wp-content/uploads/2023/08/Data-Protection-and-Privacy-Policy-Signed.pdf"
                      target="_blank"
                      >Data Privacy Policy</a
                    >
                  </span>
                </div>
              </div>
            </label>
          </div>

          <div
            class="input-errors text-sm text-red-500"
            v-for="error of v$.privacyPolicy?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Please tick this box to agree</div>
          </div>

          <div class="my-4">
            <button
              class="text-white rounded-lg w-full py-2 hover:bg-white hover:text-[#F58220] border border-[#8DC63F]"
              :disabled="loading === true"
              :class="loading ? 'bg-gray-500' : 'bg-[#8DC63F]'"
            >
              <div v-if="loading === true">
                <div
                  role="status"
                  class="flex justify-center w-full"
                  v-if="loading === true"
                >
                  <svg
                    class="inline mr-2 w-5 h-5 text-white animate-spin dark:text-gray-600 fill-[#8DC63F]"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div v-if="loading === false">Get Started</div>
            </button>
          </div>
          <div class="flex justify-between">
            <div>
              <small class="pr-1 font-bold text-gray-500"
                >Forgot your password?</small
              >
              <small
                class="text-[#09518C] cursor-pointer font-bold hover:text-[#F58220]"
                @click="toggleLoginForm(1)"
              >
                Click here
              </small>
            </div>
            <div>
              <small class="pr-1 font-bold text-gray-500"
                >Not a member yet?</small
              >
              <small
                class="text-[#09518C] cursor-pointer font-bold hover:text-[#F58220]"
                @click="toggleLoginForm(2)"
              >
                Register here
              </small>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { required, sameAs } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { toolkitAxios } from "@/env";
import lockSolid from "@/assets/lock-solid.svg";
export default {
  props: {
    // showLoginForm: Number,
    onIndemintyModalOpen: Function,
    toggleLoginForm: Function,
  },
  setup() {
    const showPassword = ref(true);
    const showErrorMsg = ref(null);
    const isIndemnityOpen = ref(false);
    const loading = ref(false);
    const resetLoading = ref(false);
    const user = ref("");
    const store = useStore();
    const state = reactive({
      password: "",
      identifier: "",
      code: "",
      check: false,
      privacyPolicy: false,
    });

    const toggleShowHide = () => {
      showPassword.value = !showPassword.value;
    };

    const rules = {
      identifier: { required },
      password: { required },
      code: { required },
      check: { sameAs: sameAs(true) },
      privacyPolicy: { sameAs: sameAs(true) },
    };

    const v$ = useVuelidate(rules, state);

    const onSubmit = async () => {
      v$.value.$touch();

      if (v$.value.$invalid) return;

      loading.value = true;

      await toolkitAxios
        .post("/employer/login", {
          code: state.code,
          identifier: state.identifier,
          password: state.password,
        })
        .then((response) => {
          localStorage.setItem("token", response.data.data.token);
          localStorage.setItem("logged_user_user_email", state.identifier);

          user.value = response.data.data;

          store.dispatch("getCurrentUser", user.value);

          window.location.href = "/user/dashboard";
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            showErrorMsg.value = error?.response?.data?.message;
          } else {
            showErrorMsg.value = "An error occurred please retry!";
          }
        });
      loading.value = false;
    };

    return {
      showPassword,
      showErrorMsg,
      v$,
      state,
      onSubmit,
      isIndemnityOpen,
      toggleShowHide,
      loading,
      user,
      resetLoading,
      lockSolid,
    };
  },
};
</script>

<style scoped>
.field-icon {
  float: right;
  margin-left: -25px;
  margin-top: -27px;
  position: relative;
  z-index: 2;
  margin-right: 15px;
}
</style>
